/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MaintenanceList } from './MaintenanceList';
import {
    MaintenanceListFromJSON,
    MaintenanceListFromJSONTyped,
    MaintenanceListToJSON,
    MaintenanceListToJSONTyped,
} from './MaintenanceList';
import type { UserProductivityList } from './UserProductivityList';
import {
    UserProductivityListFromJSON,
    UserProductivityListFromJSONTyped,
    UserProductivityListToJSON,
    UserProductivityListToJSONTyped,
} from './UserProductivityList';
import type { VehicleMovementPeriodList } from './VehicleMovementPeriodList';
import {
    VehicleMovementPeriodListFromJSON,
    VehicleMovementPeriodListFromJSONTyped,
    VehicleMovementPeriodListToJSON,
    VehicleMovementPeriodListToJSONTyped,
} from './VehicleMovementPeriodList';
import type { PreOpsAnswerList } from './PreOpsAnswerList';
import {
    PreOpsAnswerListFromJSON,
    PreOpsAnswerListFromJSONTyped,
    PreOpsAnswerListToJSON,
    PreOpsAnswerListToJSONTyped,
} from './PreOpsAnswerList';
import type { FleetAuthenticatePeriodList } from './FleetAuthenticatePeriodList';
import {
    FleetAuthenticatePeriodListFromJSON,
    FleetAuthenticatePeriodListFromJSONTyped,
    FleetAuthenticatePeriodListToJSON,
    FleetAuthenticatePeriodListToJSONTyped,
} from './FleetAuthenticatePeriodList';
import type { UserGroupDetails } from './UserGroupDetails';
import {
    UserGroupDetailsFromJSON,
    UserGroupDetailsFromJSONTyped,
    UserGroupDetailsToJSON,
    UserGroupDetailsToJSONTyped,
} from './UserGroupDetails';
import type { VehicleList } from './VehicleList';
import {
    VehicleListFromJSON,
    VehicleListFromJSONTyped,
    VehicleListToJSON,
    VehicleListToJSONTyped,
} from './VehicleList';
import type { VehicleProductivityList } from './VehicleProductivityList';
import {
    VehicleProductivityListFromJSON,
    VehicleProductivityListFromJSONTyped,
    VehicleProductivityListToJSON,
    VehicleProductivityListToJSONTyped,
} from './VehicleProductivityList';
import type { FleetStatisticsList } from './FleetStatisticsList';
import {
    FleetStatisticsListFromJSON,
    FleetStatisticsListFromJSONTyped,
    FleetStatisticsListToJSON,
    FleetStatisticsListToJSONTyped,
} from './FleetStatisticsList';
import type { ShockEventList } from './ShockEventList';
import {
    ShockEventListFromJSON,
    ShockEventListFromJSONTyped,
    ShockEventListToJSON,
    ShockEventListToJSONTyped,
} from './ShockEventList';
import type { UserList } from './UserList';
import {
    UserListFromJSON,
    UserListFromJSONTyped,
    UserListToJSON,
    UserListToJSONTyped,
} from './UserList';

/**
 * Settings for which columns should be visible in the frontend. This is a "singleton": there's only a single row on each instance. The backend does not create or delete rows, it only updates this one row.
 * @export
 * @interface ColumnVisibility
 */
export interface ColumnVisibility {
    /**
     * 
     * @type {string}
     * @memberof ColumnVisibility
     */
    id: string;
    /**
     * 
     * @type {UserList}
     * @memberof ColumnVisibility
     */
    userList: UserList;
    /**
     * 
     * @type {UserGroupDetails}
     * @memberof ColumnVisibility
     */
    userGroupDetails: UserGroupDetails;
    /**
     * 
     * @type {UserProductivityList}
     * @memberof ColumnVisibility
     */
    userProductivityList: UserProductivityList;
    /**
     * 
     * @type {VehicleList}
     * @memberof ColumnVisibility
     */
    vehicleList: VehicleList;
    /**
     * 
     * @type {VehicleProductivityList}
     * @memberof ColumnVisibility
     */
    vehicleProductivityList: VehicleProductivityList;
    /**
     * 
     * @type {VehicleMovementPeriodList}
     * @memberof ColumnVisibility
     */
    vehicleMovementPeriodList: VehicleMovementPeriodList;
    /**
     * 
     * @type {MaintenanceList}
     * @memberof ColumnVisibility
     */
    maintenanceList: MaintenanceList;
    /**
     * 
     * @type {FleetAuthenticatePeriodList}
     * @memberof ColumnVisibility
     */
    fleetAuthenticatePeriodList: FleetAuthenticatePeriodList;
    /**
     * 
     * @type {ShockEventList}
     * @memberof ColumnVisibility
     */
    shockEventList: ShockEventList;
    /**
     * 
     * @type {PreOpsAnswerList}
     * @memberof ColumnVisibility
     */
    preOpsAnswerList: PreOpsAnswerList;
    /**
     * 
     * @type {FleetStatisticsList}
     * @memberof ColumnVisibility
     */
    fleetStatisticsList: FleetStatisticsList;
}

/**
 * Check if a given object implements the ColumnVisibility interface.
 */
export function instanceOfColumnVisibility(value: object): value is ColumnVisibility {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userList' in value) || value['userList'] === undefined) return false;
    if (!('userGroupDetails' in value) || value['userGroupDetails'] === undefined) return false;
    if (!('userProductivityList' in value) || value['userProductivityList'] === undefined) return false;
    if (!('vehicleList' in value) || value['vehicleList'] === undefined) return false;
    if (!('vehicleProductivityList' in value) || value['vehicleProductivityList'] === undefined) return false;
    if (!('vehicleMovementPeriodList' in value) || value['vehicleMovementPeriodList'] === undefined) return false;
    if (!('maintenanceList' in value) || value['maintenanceList'] === undefined) return false;
    if (!('fleetAuthenticatePeriodList' in value) || value['fleetAuthenticatePeriodList'] === undefined) return false;
    if (!('shockEventList' in value) || value['shockEventList'] === undefined) return false;
    if (!('preOpsAnswerList' in value) || value['preOpsAnswerList'] === undefined) return false;
    if (!('fleetStatisticsList' in value) || value['fleetStatisticsList'] === undefined) return false;
    return true;
}

export function ColumnVisibilityFromJSON(json: any): ColumnVisibility {
    return ColumnVisibilityFromJSONTyped(json, false);
}

export function ColumnVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnVisibility {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userList': UserListFromJSON(json['userList']),
        'userGroupDetails': UserGroupDetailsFromJSON(json['userGroupDetails']),
        'userProductivityList': UserProductivityListFromJSON(json['userProductivityList']),
        'vehicleList': VehicleListFromJSON(json['vehicleList']),
        'vehicleProductivityList': VehicleProductivityListFromJSON(json['vehicleProductivityList']),
        'vehicleMovementPeriodList': VehicleMovementPeriodListFromJSON(json['vehicleMovementPeriodList']),
        'maintenanceList': MaintenanceListFromJSON(json['maintenanceList']),
        'fleetAuthenticatePeriodList': FleetAuthenticatePeriodListFromJSON(json['fleetAuthenticatePeriodList']),
        'shockEventList': ShockEventListFromJSON(json['shockEventList']),
        'preOpsAnswerList': PreOpsAnswerListFromJSON(json['preOpsAnswerList']),
        'fleetStatisticsList': FleetStatisticsListFromJSON(json['fleetStatisticsList']),
    };
}

export function ColumnVisibilityToJSON(json: any): ColumnVisibility {
    return ColumnVisibilityToJSONTyped(json, false);
}

export function ColumnVisibilityToJSONTyped(value?: ColumnVisibility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userList': UserListToJSON(value['userList']),
        'userGroupDetails': UserGroupDetailsToJSON(value['userGroupDetails']),
        'userProductivityList': UserProductivityListToJSON(value['userProductivityList']),
        'vehicleList': VehicleListToJSON(value['vehicleList']),
        'vehicleProductivityList': VehicleProductivityListToJSON(value['vehicleProductivityList']),
        'vehicleMovementPeriodList': VehicleMovementPeriodListToJSON(value['vehicleMovementPeriodList']),
        'maintenanceList': MaintenanceListToJSON(value['maintenanceList']),
        'fleetAuthenticatePeriodList': FleetAuthenticatePeriodListToJSON(value['fleetAuthenticatePeriodList']),
        'shockEventList': ShockEventListToJSON(value['shockEventList']),
        'preOpsAnswerList': PreOpsAnswerListToJSON(value['preOpsAnswerList']),
        'fleetStatisticsList': FleetStatisticsListToJSON(value['fleetStatisticsList']),
    };
}

